import { useEffect } from 'react'
import { useCohort, useHasSeenOpenPaymentSchedule, useIsBillingAgreementApprovalProcess } from '../../state'
import { Cohort } from '@afterpaytouch/portal-api'

export const usePaymentScheduleInitialOpenStatus = (): boolean => {
  const cohort = useCohort()
  const { hasSeenOpenPaymentSchedule, saveToTags } = useHasSeenOpenPaymentSchedule()
  const isAPCohort = cohort === Cohort.APOnly

  const shouldShowOpenPaymentSchedule = !isAPCohort && !hasSeenOpenPaymentSchedule

  useEffect(() => {
    if (shouldShowOpenPaymentSchedule) {
      saveToTags()
    }
  }, [shouldShowOpenPaymentSchedule, saveToTags])

  return isAPCohort ? false : shouldShowOpenPaymentSchedule
}

// Hook for billing approval, everything is just hardcoded unless requirements change
export const useGetBillingApprovalSchedule = (): {
  installmentCount: number
  installmentPercentage: number
  installmentCadence: number
  installmentTimeline: number[]
} | null => {
  const isBillingAgreementApprovalProcess = useIsBillingAgreementApprovalProcess()

  if (!isBillingAgreementApprovalProcess) {
    return null
  }

  return {
    installmentCount: 4,
    installmentPercentage: 25,
    installmentCadence: 2,
    installmentTimeline: [0, 2, 4, 6],
  }
}
